import { PointFeature } from '@lidea/shared/util/types';

export function sortPointsByZone(points: PointFeature[]): PointFeature[] {
  return [...points].sort((a, b) => {
    const zoneDiff = a.properties.zone - b.properties.zone;
    if (zoneDiff !== 0) {
      return zoneDiff;
    }
    return Number(a.id) - Number(b.id);
  });
}

export function getAdjacentPointId(
  points: PointFeature[],
  selectedPointId: number | null,
  direction: 'prev' | 'next'
): number | null {
  const sorted = sortPointsByZone(points);
  if (!sorted.length) {
    return null;
  }

  const currentIndex = sorted.findIndex(
    (point) => Number(point.id) === Number(selectedPointId)
  );

  if (currentIndex === -1) {
    return sorted[0].id;
  }

  const offset = direction === 'next' ? 1 : -1;
  const nextIndex =
    (currentIndex + offset + sorted.length) % sorted.length;

  return sorted[nextIndex].id;
}
